import invariant from 'invariant';

const insertScript = (onLoaded) => {
  const recaptchaScript = document.createElement('script');
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'recaptchaOnloadCallback' does not exist ... Remove this comment to see the full error message
  window.recaptchaOnloadCallback = onLoaded;
  recaptchaScript.setAttribute(
    'src',
    `//www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&` +
      `render=explicit&hl=${USER_LOCALE}`
  );
  recaptchaScript.setAttribute('async', 'async');
  recaptchaScript.setAttribute('defer', 'defer');
  invariant(document.head, 'Missing document.head');
  document.head.appendChild(recaptchaScript);
};

let loadingPromise;
export const resetRecaptcha = () =>
  window && window.grecaptcha && window.grecaptcha.reset();
export default () => {
  if (!loadingPromise) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    loadingPromise = new Promise<any>((resolve) => {
      insertScript(() => {
        resolve(grecaptcha);
      });
    });
  }

  return loadingPromise;
};
